<template>
  <v-btn v-bind="$attrs" tile depressed class="error" @click="$emit('click')">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>

<style></style>
